module.exports = __webpack_public_path__ + "static/intertec_clientProject-b9c9f5f75a489e3fa2046138f11e3f21.avif";